import GenericFileUpload from "../../../../../components/genericFileUpload/GenericFileUpload";

interface Props{
    name:string,
    values:any,
setValues: React.Dispatch<React.SetStateAction<any>>;
}

const OrderSummaryConfigCustom=(props:Props)=>{

  function setBlobkey(blobKey: any) {
    let keyName = "orderTncLink";
    props.setValues({
      ...props.values,
      [keyName]: {
        ...props.values[keyName],
        value: blobKey,
        isValueUpdated: true,
        domainType: "order_configuration",
      },
    });
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     [keyName]: {
    //       ...values[keyName],
    //       value: blobKey,
    //       isValueUpdated: true,
    //       domainType: "order_configuration",
    //     },
    //   },
    //   orderConfig,
    //   defaultInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  }
    return(
        <>
         {props.values?.orderTncVisibility?.value && (
          
                        <div style={{padding:"0px",backgroundColor:"#f8fafc"}} >
                    <div  style={{fontWeight:500,color:"#000000", marginBottom:"16px",fontSize:"15px"}} >
                           Upload Order Tnc File
                   </div>      
                          <GenericFileUpload
                            className="ui-upload-container"
                            label={"Upload pdf Document"}
                            defaultFile={props.values?.orderTncLink?.value}
                            setDefaultFile={setBlobkey}
                            accept={{
                              image: ["png", "jpeg", "jpg"],
                              application: [
                                "pdf",
                                "vnd.ms-excel",
                                "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              ],
                            }}
                            fetchBlobKey={true}
                            resolution={{
                              height: 0,
                              width: 0,
                            }}
                          />
                        </div>
                      )}
        </>
    )
}
export default OrderSummaryConfigCustom